<h4 class="font-light text-base mb-3 mt-1">
  Select 8bit, 16bit, RGB or multichannel z-stack .TIFF
</h4>

<form [formGroup]="form" (ngSubmit)="onSubmit()">

  <p-divider align="left">
    <div class="inline-flex align-items-center">
      <b>Settings</b>
    </div>
  </p-divider>

  <!-- gradient kernel -->
  <div class="field grid h-3rem align-items-center my-1">
    <label class="col-12 md:col-5 mb-0 text-black-alpha-90">
        Gradient Kernel
        <i class="pi pi-info-circle px-1"
          pTooltip="Size of kernel used to measure focus - use larger values for noisier input"
          tooltipPosition="top"
        ></i>
    </label>
    <!--
    <div class="col-12 md:col-7">
      <p-inputNumber
        inputId="gradientKernel"
        formControlName="gradientKernel"
        [showButtons]="true"
        [min]="0"
        [max]="10"
      ></p-inputNumber>
    </div> -->
    <div class="col-12 md:col-7">
      <p-dropdown
        formControlName="gradientKernel"
        placeholder="SELECT SIZE"
        [options]="gradientKernelOptions"
        optionLabel="name"
        class="p-inputtext-sm"
        optionValue="value"
      ></p-dropdown>
    </div>
  </div>

  <!-- noise filter -->
  <div class="field grid h-3rem align-items-center my-1">
    <label class="col-12 md:col-5 mb-0 text-black-alpha-90">
        Noise Filter
        <i class="pi pi-info-circle px-1"
          pTooltip="Size of noise filter applied to z-map"
          tooltipPosition="top"
        ></i>
    </label>
    <div class="col-12 md:col-7">
      <!--
      <p-inputNumber
        inputId="noiseFilter"
        formControlName="noiseFilter"
        [showButtons]="true"
        [min]="0"
        [max]="10"
      ></p-inputNumber> -->
      <p-dropdown
        formControlName="noiseFilter"
        placeholder="SELECT SIZE"
        [options]="noiseFilterSizesOptions"
        optionLabel="name"
        class="p-inputtext-sm"
        optionValue="value"
      ></p-dropdown>
    </div>
  </div>

  <!-- low pass -->
  <div class="field grid h-3rem align-items-center my-1">
    <label class="col-12 md:col-5 mb-0 text-black-alpha-90">
        Low-Pass Filter
        <i class="pi pi-info-circle px-1"
          pTooltip="Size of z-map smoothing filter"
          tooltipPosition="top"
        ></i>
    </label>
    <div class="col-12 md:col-7">
      <p-inputNumber
        inputId="lowPass"
        formControlName="lowPass"
        [showButtons]="true"
        [min]="0"
        [max]="25"
        class="p-inputtext-sm"
      ></p-inputNumber>
    </div>
  </div>

  <!-- image output -->
  <ng-container>
    <p-divider align="left">
      <div class="inline-flex align-items-center font-bold">
        File Destination
      </div>
    </p-divider>

    <div class="field grid h-3rem align-items-center">
      <label for="fnOutputFolder" class="col-12 md:col-5 mb-0 text-black-alpha-90">
        Output Folder:
        <i class="pi pi-info-circle px-1"
           pTooltip="The output path set can be a full path if leading with '/' and ending with '/'.
           Otherwise, the results will be saved in the folder name provided in the directory of the input
           file(s) selected. If no file is selected, an output directory with the same name as the selected
           file will be created and the results saved in it."
           tooltipPosition="top"
        ></i>
      </label>
      <div class="col-12 md:col-7">
      <span *ngIf="!isOutputFolderEditable">
        {{form.controls['outputFolder'].value}}
        <i class="pi pi-pencil icon-hover mx-2" (click)="onEditOutputFolderName(true)"></i>
      </span>
        <span *ngIf="isOutputFolderEditable" class="p-input-icon-right">
        <i class="pi pi-times icon-hover" (click)="onEditOutputFolderName(false)"></i>
        <input id="fnOutputFolder" type="text" class="p-inputtext-sm w-full"
               formControlName="outputFolder" pInputText/>
      </span>
      </div>
    </div>

		<div class="pt-3 pb-3 process-buttons flex align-items-center gap-3">
		  <app-submit-button
		    label="Run"
		    [isSubmitting]="isSubmitting"
				[processName]="processName"
		    [validationMessage]="validationMessage"
		    icon="pi pi-play"
		    styleClass="p-button-primary"
		    [tooltip]="'Run ' + processName"
		  ></app-submit-button>
		  <button pButton type="button" label="Create Rule" icon="pi pi-bell" class="p-button-outlined"
		          [disabled]="(canCreateRule$ | async) === false || form.invalid"
		          pTooltip="Auto-run this on every new file in the selected folder."
		          (click)="onCreateRule()"></button>
		</div>

  </ng-container>
</form>
